module.exports = __webpack_public_path__ + "img/durham-logo-dark.539fcefa.png";